import { el } from "../../functions/create-element";
import { modal } from "../../functions/modal";
import { delStorage, getStorage, setStorage } from "../../helpers/storage";
export function compare(selector) {
    const buttons = document.querySelectorAll(selector ? `${selector} .add-to-compare` : '.add-to-compare');
    let compare = JSON.parse(getStorage('compare')) || [];
    if (!buttons)
        return;
    const containsObject = function (list, obj) {
        for (let i = 0, max = list.length; i < max; i++) {
            if (JSON.stringify(list[i]) == JSON.stringify(obj)) {
                return true;
            }
        }
        return false;
    };
    const removeObjectFromList = function (list, obj) {
        const newList = [];
        for (let i = 0, max = list.length; i < max; i++) {
            const data = JSON.stringify(obj).substring(1, JSON.stringify(obj).length - 1);
            if (!JSON.stringify(list[i]).includes(data)) {
                newList.push(list[i]);
            }
        }
        return newList;
    };
    const checkCompare = (button, data) => {
        if (containsObject(compare, data)) {
            button.classList.add('added');
            button.setAttribute('aria-label', __('Usuń z porównania'));
        }
        else {
            button.classList.remove('added');
            button.setAttribute('aria-label', __('Dodaj do porównania'));
        }
    };
    buttons.forEach(button => {
        if (!button.classList.contains('js-add-to-compare')) {
            const category_id = button.getAttribute('data-category');
            const product_id = button.getAttribute('data-product');
            const product_name = button.getAttribute('data-name');
            const product_ico = button.getAttribute('data-image');
            const list_url = button.getAttribute('data-list-url');
            const data = {
                category: category_id,
                product: product_id,
                name: product_name,
                ico: product_ico,
                list_url: list_url
            };
            checkCompare(button, data);
            button.addEventListener("click", () => compareToggle(button, data));
            // Oznacz przycisk, że ma już event listener.
            button.classList.add('js-add-to-compare');
        }
    });
    const compareToggle = (button, data) => {
        if (containsObject(compare, data)) {
            const new_compare = removeObjectFromList(compare, data);
            if (new_compare.length) {
                compare = new_compare;
                setStorage('compare', JSON.stringify(new_compare));
            }
            else {
                compare = [];
                delStorage('compare');
            }
            checkCompare(button, data);
            const message = el('div', {}, [
                el('span', {}, __('Produkt: ')),
                el('b', {}, `"${data.name}"`),
                el('span', {}, [__(' został usunięty z '), el('a', { href: data.list_url, class: 'contents' }, __('porównania'))]),
            ]);
            modal(__('Produkt usunięty z porównania'), message, 'icon--control-shuffle');
        }
        else {
            compare.push(data);
            setStorage('compare', JSON.stringify(compare));
            checkCompare(button, data);
            const moduleUrl = data.list_url;
            const moduleLink = moduleUrl ? el('a', { href: moduleUrl, class: 'btn-black' }, __('Przejdź do porównania')) : null;
            const moduleButtons = moduleLink ? el('div', { class: "buttons" }, moduleLink) : null;
            const message = el('div', {}, [
                el('span', {}, __('Produkt: ')),
                el('b', {}, `"${data.name}"`),
                el('span', {}, __(' został dodany do porównania')),
                moduleButtons
            ]);
            modal(__('Produkt dodany do porównania'), message, 'icon--control-shuffle');
        }
    };
}
